import React from "react";
import { object } from "prop-types";

import CardImage from "../../../atoms/cardimage";

import "./image-gallery.m.css";

const ImageGallery = ({ element, card, story }) => {
  const totalLength = element["story-elements"].length;

  return (
    <ul styleName="wrapper">
      {totalLength &&
        element["story-elements"].map((image, index) => {
          const { width, height } = image["image-metadata"];
          const isVerticalImage = height > width;

          const ImageData = {
            "hero-image-s3-key": image["image-s3-key"],
            "hero-image-metadata": image["image-metadata"],
            "hero-image-caption": image.title,
          };

          const getNumber = (val) => (val >= 10 ? val : `0${val}`);

          return (
            <li styleName={`item ${isVerticalImage ? "is-vertical" : ""}`} key={index}>
              <div styleName="content-block">
                <div styleName="count">{`${getNumber(index + 1)}/${getNumber(totalLength)}`}</div>
                <div styleName="text">
                  <span styleName="caption" dangerouslySetInnerHTML={{ __html: image.title }} />
                  <span styleName="attribution" dangerouslySetInnerHTML={{ __html: image["image-attribution"] }} />
                </div>
              </div>
              <div styleName="image-block">
                <CardImage
                  story={ImageData}
                  defaultWidth={480}
                  widths={[250, 480, 764]}
                  aspectRatio={isVerticalImage ? [3, 4] : [4, 3]}
                  imageType={isVerticalImage ? "image3x4" : "image4x3"}
                />
              </div>
            </li>
          );
        })}
    </ul>
  );
};

ImageGallery.propTypes = {
  element: object,
  card: object,
  story: object,
};

export default ImageGallery;
